/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval simport AngelAiHeader from "../AngelAiHeader/AngelAiHeader";of Celligence report
 * the incident to legal@celligence.com.
 *
 */

import React, { useState } from "react";
import { Navbar } from "react-bootstrap";
import "./index.css";
import { isMobileOrTablet } from "../Utils";
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu/index";
import RigVedQuotes from "../RigvedQuotes/index";


const isAngelAi = process.env.REACT_APP_DOMAIN === "angelai";

const HeaderNavbar = () => {
  const [navbar, setNavbar] = useState(false);
  const [showRigVedQuotes, setShowRigVedQuotes] = useState(false);
  const isMobileOrTabletDevice = isMobileOrTablet();
  let prevScrollPos = window.scrollY;

  window.onscroll = function () {
    const currentScrollPos = window.scrollY;
    const menuNavbar = document.getElementById("menuNavbar");

    if (currentScrollPos === 0) {
      menuNavbar?.classList.remove("navbarTransition");
      setNavbar(false);
    } else {
      if (prevScrollPos > currentScrollPos) {
        setNavbar(true);
      } else if (prevScrollPos < currentScrollPos) {
        if (!isMobileOrTabletDevice) {
          setNavbar(true);
        } else {
          setNavbar(false);
          menuNavbar?.classList.add("navbarTransition");
          setShowRigVedQuotes(false);
        }
      }
    }
    prevScrollPos = currentScrollPos;
  };


  return (
    <>
      <div>
          <Navbar
            id="menuNavbar"
            collapseOnSelect
            expand="lg"
            fixed="top"
            bg="dark"
            variant="dark"
            className={navbar ? "navbar active" : "navbar"}
          >
            <Navbar.Brand className="">
              <a
                href="https://www.swmc.com/"
                target="_blank"
                rel="noopener noreferrer"
                title="Sun West Mortgage Logo"
              >
                <img
                  src={`${process.env.REACT_APP_CDN_LINK}swmc-images/Homepage/New/SunWest41YearsofTrust-White.svg`}
                  className="main_logo img-fluid"
                  alt="Sun West Logo"
                />
              </a>
            </Navbar.Brand>
            <div className="header-right-section">
              <div className="angelai-section">
                <a
                  href="https://www.angelai.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={`${process.env.REACT_APP_CDN_LINK}angel-ai/latest-angelai-logo.webp`}
                    className="angelai-logo"
                    alt="AngelAi Logo"
                  />
                </a>
                <div className="tagline-container">
                  <p
                    className="brand-tagline"
                    onClick={() => setShowRigVedQuotes(true)}
                    onMouseOver={() => setShowRigVedQuotes(true)}
                    onMouseOut={() => setShowRigVedQuotes(false)}
                  >
                    Nothing Is Beyond Reach
                  </p>
                  <RigVedQuotes showRigVedQuotes={showRigVedQuotes} />
                </div>
              </div>
              <UserWayAccessibilityMenu
                color="white"
                width={40}
                height={40}
              />
            </div>
          </Navbar>
      </div>
    </>
  );
};

export default HeaderNavbar;
